import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";


const features = [
    {
        title: "Chatbots and Virtual Assistants",
        description: "Enhance customer support with AI-driven chatbots that understand and respond to natural language queries.",
        imgUrl: "./img/services/nlp-solutions/chatbots-and-virtual-assistants.png",
    },
    {
        title: "Sentiment Analysis",
        description: "Analyze customer feedback to gauge public opinion and improve decision-making processes.",
        imgUrl: "./img/services/nlp-solutions/sentiment analysis.jpg",
    },
    {
        title: "Text Summarization",
        description: "Automatically generate concise summaries of lengthy documents, saving time and effort.",
        imgUrl: "./img/services/nlp-solutions/text-summarization.jpg",
    },
    {
        title: "Language Translation",
        description: "Break language barriers with real-time translation for global communication.",
        imgUrl: "./img/services/nlp-solutions/language-translation.jpg",
    },
    {
        title: "Voice Recognition",
        description: "Enable voice-driven interfaces and transcription with advanced voice recognition technology.",
        imgUrl: "./img/services/nlp-solutions/voice-recognition.jpg",
    },
    {
        title: "Content Moderation",
        description: "Automate the detection and filtering of inappropriate or harmful content on digital platforms.",
        imgUrl: "./img/services/nlp-solutions/content-moderation.png",
    },
];


const NLPSolutions = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "NLP Solutions", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="NLP Solutions" description="Revolutionize communication, enhance customer experiences, and automate text and voice processes with NLP-powered solutions." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is NLP?</h2>
                            <p>
                                Natural Language Processing (NLP) combines computational linguistics with AI to enable machines to understand, interpret, and generate human language. It empowers businesses to analyze text, voice, and data efficiently and effectively.
                            </p>
                            <img
                                src="./img/services/nlp-solutions.jpg"
                                alt="NLP Overview Illustration"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Our Key Services</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Benefits of NLP Solutions</h2>
                            <ul>
                                <li>Improve customer satisfaction with intelligent communication tools.</li>
                                <li>Streamline workflows with automated text and voice processing.</li>
                                <li>Gain insights from unstructured data like social media and reviews.</li>
                                <li>Enhance accessibility with real-time translations and voice interfaces.</li>
                                <li>Optimize decision-making with sentiment and trend analysis.</li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Unlock the Power of NLP</h2>
                            <p>
                                Partner with us to integrate cutting-edge NLP solutions into your business. <br />
                                Contact us at <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>.
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default NLPSolutions;
